<div id="area-faqs">
  @if (!faqs) {
    <div>
      <div class="{{style === 'light' ? 'bg-primary-50': 'bg-primary-900'}} border-radius-4 p-5">
        <div class="row">
          <div class="col-12 text-center mb-4">
            <span class="material-symbols-outlined">sync</span>
          </div>
          <div class="col-12 text-center">
            <span class="p1-medium neutral-800">
              Estamos <strong class="p1-bold">actualizando</strong> las <strong class="p1-bold">preguntas frecuentes</strong>.
              <br> Vuelve pronto para resolver todas tus dudas.
              </span>
            </div>
          </div>
        </div>
      </div>
    }

    @if (faqs) {
      <mat-accordion>
        @for (faq of faqs; track faq) {
          <mat-expansion-panel hideToggle #panel class="faqs-accordion border-bottom-1 expansion-{{style}} {{style === 'light' ? 'bg-white border-primary-900': 'bg-primary-900 border-primary-500'}}"
            >
            <mat-expansion-panel-header class="px-lg-4 faqs-header" title="{{faq.pregunta}}">
              <mat-panel-title class="faqs-title p1-semibold mb-0" [ngClass]="{'primary-50' : style === 'dark', 'primay-900': style === 'light'}"> {{ faq.pregunta }} </mat-panel-title>
              @if (style === 'light') {
                <span class="material-symbols-outlined primary-900 filled">{{ panel.expanded ? "remove_circle" : "add_circle" }}</span>
              }
              @if (style === 'dark') {
                <span class="material-symbols-outlined">{{ panel.expanded ? "keyboard_arrow_up" : "keyboard_arrow_down" }}</span>
              }
            </mat-expansion-panel-header>
            <div class="mt-3 {{style === 'light' ? 'neutral-800' : 'primary-50'}}" [innerHTML]="faq.respuesta"></div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  </div>